const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/samedan/setup.ts';
import { PatAppConfiguration } from 'App/defs/setupDefs';
import { useECheckinInitialValues } from './eCheckin/initialValues';
import Footer from 'App/config/samedan/Footer';

export const configuration: PatAppConfiguration = {
    languages: ['de', 'fr', 'en', 'it'],
    footer: Footer,
    eCheckin: {
        initialValuesHook: useECheckinInitialValues,
        form: undefined,
    },
    urls: {
        website: 'https://www.spital-oberengadin.ch/',
        loginHelp: undefined,
    },
    navbarTitle: undefined,
    welcomeTitle: undefined,
    welcomeText: undefined,
    synedraCardTitle: undefined,
    customMetaKatMultipleKeys: {
        Countries: 'Lookup/71221995-e5b8-4b70-9b2f-d3400f9105d3/Children',
        Beruf: 'Lookup/1cb70405-be64-409b-909f-571162d2ba43/Children',
        Beziehung: 'Lookup/9c8b19c0-a8df-4164-ae64-f7994d4b201d/Children',
        Geschlecht: 'Lookup/75c0572b-c147-47c5-9762-952a3cccbc87/Children',
        Zivilstand: 'Lookup/30bc0a1c-07ee-456f-a675-b3b439ac126a/Children',
        Behandlungsgrund: 'Lookup/c29e943a-08b5-451d-960b-57a0687a8f89/Children',
        Versicherung: 'Lookup/be4cf0af-8c7a-4b50-95c6-8c4fd7c4024a/Children',
        Klasse: 'Lookup/7bb822b2-45ff-4300-a52a-424b9f6c3956/Children',
        YesNo: 'Lookup/dc900b81-52a6-4892-9f14-daab61e07443/Children',
    },
    customMatomoClientId: 7,
    bookAppointmentInfo: undefined,
    bookAppointmentSlotOffset: {
        amount: 24,
        unit: 'hours',
    },
    surgeryCardHint: undefined,
    SurgeryCardContactAlert: undefined,
    surgeryAppointmentDeadline: undefined,
    videoCallDisclaimerText: undefined,
    aiaiBotApiKey: undefined,
};

export const { customMetaKatMultipleKeys } = configuration;
